import { TaskType } from './../../shared/enums/task-type-enum';

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZE_OPTIONS = [20, 40, 60, 100];
export const UNLIMITED = -1;
export const JOBS_LIST = [
    TaskType.CALCULATE_FOLIOS_MULTI_THREAD,
    TaskType.GET_3D_TILES_DATA,
    TaskType.GET_AUTOMATION_DATA_JOB,
    TaskType.FILL_ZC_APPLICABLE_TYPOLOGIES,
    TaskType.CALCULATE_ALL_TYPOLOGIES,
    TaskType.RECALCULATE_LISTED_BY_STATUS_JOB,
    TaskType.REMOVE_PROPERTY_RECORDS,
    TaskType.REPLACE_LAND_USE_IDS,
    TaskType.COLLECT_PRS_ZONING_DATA,
    TaskType.COLLECT_PRS_OVERLAYS_DATA,
    TaskType.COLLECT_PRS_MARKET_DATA,
    TaskType.SYNC_ZONING_CODE_SOLR_DATA,
    TaskType.REMOVE_ZONING_CODE_SOLR_DATA,
    TaskType.REMOVE_ZCV_CRS_JOB,
    TaskType.REMOVE_ZONING_CODE_JOB,
    TaskType.SYNC_ZC_PRS_JOB,
    TaskType.REINDEX_MISSED_ZC_AU_JOB,
    TaskType.FILL_BUILDING_MODEL_GEOMETRIES_JOB,
    TaskType.CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB
];
export const SEARCHABLE_JOBS_LIST = JOBS_LIST.concat([TaskType.RECALCULATE_BY_STATUS_MULTI_THREAD]);

export const ZC_RELATED_TASKS = [
    TaskType.ZONING_CODE_INDEXING,
    TaskType.ZONING_CODE_INDEXING_WITH_CURSOR,
    TaskType.ZC_VERSION_CALCULATION
];
export const DEFAULT_FILE = {
    name: 'No file chosen',
    isDefault: true
};
export const MAX_FILE_SIZE = 6291456; // 6 Mb

export const PROCESS_DYNAMIC_PROPERTIES = [
    'maxThreadsCount',
    'needToRecalculate',
    'name',
    'place',
    'maxPRsBunchSize',
    'dataSourceCategories',
    'allowedThreadsCount'
];

export const PROCESS_DYNAMIC_PROPERTIES_NAMES = {
    maxThreadsCount: 'Max threads count',
    needToRecalculate: 'Need to recalculate',
    name: 'Name',
    place: 'Place',
    maxPRsBunchSize: 'Max PRs bunch size',
    dataSourceCategories: 'Data source categories',
    allowedThreadsCount: 'Active threads count'
};
